// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Abnahme, Gewährleistung, Bürgschaften: scoped to .warranty-page (modals use rootClassName). */

.warranty-page .wty-full {
  width: 100%;
}

.warranty-page .wty-small {
  font-size: 12px;
  color: var(--ds-text-secondary, #5a6f7e);
  overflow-wrap: anywhere;
}

.warranty-page .wty-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.warranty-page .wty-pre {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.warranty-page .wty-label {
  font-size: 12px;
  color: var(--ds-text-secondary, #5a6f7e);
  margin-block-end: 4px;
}

.warranty-page .wty-empty-text {
  max-width: 520px;
  margin-inline: auto;
}

.warranty-page .wty-link {
  padding: 0;
  height: auto;
  font-weight: 600;
  white-space: normal;
  text-align: start;
}

.warranty-page .wty-link-text {
  overflow-wrap: anywhere;
}

.warranty-page .wty-row {
  flex: 1 1 auto;
  min-width: 0;
}

.warranty-page .wty-row-tags {
  flex: 0 0 auto;
  justify-content: flex-end;
}

.warranty-page .wty-tile .ant-statistic-content {
  font-size: 22px;
}

.warranty-page .wty-header {
  display: flex;
  align-items: flex-start;
  gap: var(--ds-space-2, 8px);
  flex-wrap: wrap;
}

.warranty-page .wty-header-title {
  flex: 1 1 220px;
  min-width: 0;
}

.warranty-page .wty-header-title h4 {
  margin: 0 0 4px;
  overflow-wrap: anywhere;
}

.warranty-page .wty-header-actions {
  justify-content: flex-end;
}

.warranty-page .wty-defect-head {
  margin-block-end: 6px;
}

.warranty-page .wty-photos {
  margin-block-start: 8px;
}

.warranty-page .wty-photo {
  position: relative;
}

.warranty-page .wty-photo .ant-btn {
  position: absolute;
  inset-block-start: 0;
  inset-inline-end: 0;
  background: var(--ds-surface, #fff);
}

.warranty-page .wty-photo .ant-image-img {
  object-fit: cover;
  border-radius: 6px;
}

.warranty-page .wty-signature {
  max-width: 100%;
  max-height: 80px;
  display: block;
}

.warranty-page .wty-checks {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.warranty-page .wty-divider {
  margin-block: 8px 16px;
}

.warranty-page.wty-public {
  min-height: 100vh;
  background: var(--ds-bg);
  padding: var(--ds-space-4, 16px) 16px;
}

.warranty-page .wty-public-inner {
  max-width: 820px;
  margin-inline: auto;
}

.warranty-page .wty-public-company {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-block-end: 16px;
}

.warranty-page .wty-public-company img {
  max-height: 40px;
  max-width: 160px;
}

@media (max-width: 767px) {
  .warranty-page .wty-header-actions {
    width: 100%;
    justify-content: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/warranty/warranty.css"],"names":[],"mappings":"AAAA,gGAAgG;;AAEhG;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,2BAA2B;EAC7B;AACF","sourcesContent":["/* Abnahme, Gewährleistung, Bürgschaften: scoped to .warranty-page (modals use rootClassName). */\n\n.warranty-page .wty-full {\n  width: 100%;\n}\n\n.warranty-page .wty-small {\n  font-size: 12px;\n  color: var(--ds-text-secondary, #5a6f7e);\n  overflow-wrap: anywhere;\n}\n\n.warranty-page .wty-clamp {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.warranty-page .wty-pre {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.warranty-page .wty-label {\n  font-size: 12px;\n  color: var(--ds-text-secondary, #5a6f7e);\n  margin-block-end: 4px;\n}\n\n.warranty-page .wty-empty-text {\n  max-width: 520px;\n  margin-inline: auto;\n}\n\n.warranty-page .wty-link {\n  padding: 0;\n  height: auto;\n  font-weight: 600;\n  white-space: normal;\n  text-align: start;\n}\n\n.warranty-page .wty-link-text {\n  overflow-wrap: anywhere;\n}\n\n.warranty-page .wty-row {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.warranty-page .wty-row-tags {\n  flex: 0 0 auto;\n  justify-content: flex-end;\n}\n\n.warranty-page .wty-tile .ant-statistic-content {\n  font-size: 22px;\n}\n\n.warranty-page .wty-header {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--ds-space-2, 8px);\n  flex-wrap: wrap;\n}\n\n.warranty-page .wty-header-title {\n  flex: 1 1 220px;\n  min-width: 0;\n}\n\n.warranty-page .wty-header-title h4 {\n  margin: 0 0 4px;\n  overflow-wrap: anywhere;\n}\n\n.warranty-page .wty-header-actions {\n  justify-content: flex-end;\n}\n\n.warranty-page .wty-defect-head {\n  margin-block-end: 6px;\n}\n\n.warranty-page .wty-photos {\n  margin-block-start: 8px;\n}\n\n.warranty-page .wty-photo {\n  position: relative;\n}\n\n.warranty-page .wty-photo .ant-btn {\n  position: absolute;\n  inset-block-start: 0;\n  inset-inline-end: 0;\n  background: var(--ds-surface, #fff);\n}\n\n.warranty-page .wty-photo .ant-image-img {\n  object-fit: cover;\n  border-radius: 6px;\n}\n\n.warranty-page .wty-signature {\n  max-width: 100%;\n  max-height: 80px;\n  display: block;\n}\n\n.warranty-page .wty-checks {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.warranty-page .wty-divider {\n  margin-block: 8px 16px;\n}\n\n.warranty-page.wty-public {\n  min-height: 100vh;\n  background: var(--ds-bg);\n  padding: var(--ds-space-4, 16px) 16px;\n}\n\n.warranty-page .wty-public-inner {\n  max-width: 820px;\n  margin-inline: auto;\n}\n\n.warranty-page .wty-public-company {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-block-end: 16px;\n}\n\n.warranty-page .wty-public-company img {\n  max-height: 40px;\n  max-width: 160px;\n}\n\n@media (max-width: 767px) {\n  .warranty-page .wty-header-actions {\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
